import React from "react";
import { Row, Col } from "reactstrap";
import "./covered-item.scss";

class CoveredItem extends React.Component {
  render() {
    return (
      <Row className={"m-0 p-0 covered-item"}>
        <Col lg={"auto"} xs={"auto"} className={"m-0 p-0"}>
          <img className="tick-icon" src={this.props.icon} alt="" />
        </Col>
        <Col className={"m-0 p-0"}>
          <h3 className={"font-weight-bold title"}>{this.props.title}</h3>
          <h3 className={"sub-title"}>{this.props.subTitle}</h3>
        </Col>
      </Row>
    );
  }
}

export default CoveredItem;
